import Vue from 'vue';
import axios from 'axios';
// import Helper from './_helper';

// var __h = new Helper();
const vue_recommend = new Vue({
	el: '#topRecommend',
	data: {
		url: 'https://sgs.liranet.jp/cms/wp-json/sgs/v1/freespace',
		posts: [],
		errors: [],
		isActive: false
	},
	created() {
		axios.get(this.url)
			.then(response => {
				this.posts = response.data;
				this.isActive = true;
			})
			.catch(e => {
				this.errors.push(e)
			});
	}
});